'use client';

import { Flex, Text } from '@chakra-ui/react';
import Script from 'next/script';
import { useTranslations } from 'next-intl';
export default function Bridge() {
  const t = useTranslations();
  return <>
      {/* 
       // @ts-ignore  */}
      <style jsx global>{`
        .MuiTypography-subtitle1 {
          color: #fff !important;
        }
        .MuiSvgIcon-root {
          color: #fff !important;
          fill: #fff !important;
        }
        .MuiScopedCssBaseline-root {
          background: transparent !important;
        }
        .MuiPaper-root {
          color: #ccc;
          background: linear-gradient(to top, #131313, #131313, #131313);
          border: 1px solid #5e5e5e;
        }
        .MuiInputBase-root {
          border: none;
          background: #242424;
        }
        .MuiFab-root {
          border-radius: 12px;
          height: 48px;
          width: 48px;
          margin-top: 12px;
          margin-bottom: 12px;
          box-shadow: inset 0px -2px 0px rgba(0, 0, 0, 0.1);
          background: linear-gradient(to left, #0154fe, #37c0df);
          border: 1px solid white;
        }
        .MuiFab-root:hover {
          background: linear-gradient(to right, #0154fe, #37c0df);
        }
        .MuiFab-root:active {
          box-shadow: inset 0px 0px 12px rgba(0, 0, 0, 1), 0px 0px 12px #fff !important;
        }
        .MuiButton-containedPrimary {
          transition: background-color 0.2s, opacity 0.2s;
          box-shadow: 0px -1px 0px 0px rgba(14, 14, 44, 0.4) inset;
          background: linear-gradient(to left, #0154fe, #37c0df);
          color: #fff;
          font-weight: 500;
          text-transform: uppercase;
          font-size: 14px;
          border-radius: 8px;
          border: 2px solid;
          height: 48px;
          border-color: #fff;
          width: 100%;
          padding: 12px;
        }
        .MuiButton-containedPrimary:hover {
          background: linear-gradient(to right, #0154fe, #37c0df);
          color: #fff;
        }
        .MuiButton-containedPrimary:active {
          opacity: 0.85;
          -webkit-transform: translateY(1px);
          -ms-transform: translateY(1px);
          transform: translateY(1px);
          background: transparent !important;
          box-shadow: none;
          color: #fff;
        }
        .MuiButton-contained.Mui-disabled,
        .MuiButton-contained.Mui-disabled:hover {
          background: transparent !important;
          box-shadow: none !important;
        }
      `}</style>
      <Script src="https://unpkg.com/@layerzerolabs/stargate-ui@latest/element.js" defer async data-sentry-element="Script" data-sentry-source-file="page.tsx" />

      <Text fontSize="24px" textAlign="center" marginTop={20} data-sentry-element="Text" data-sentry-source-file="page.tsx">
        {t('Bridge')}
      </Text>
      <Text textAlign="center" data-sentry-element="Text" data-sentry-source-file="page.tsx">{t('Powered by Stargate')}</Text>

      <Flex width="95%" minWidth="95%" justifyContent="center" position="relative" marginLeft="auto" marginRight="auto" marginTop={5} marginBottom={60} data-sentry-element="Flex" data-sentry-source-file="page.tsx">
        {/* 
              // @ts-ignore  */}
        <stargate-widget theme="dark" partnerId="0x0019" feeCollector="0x34D13FCF6150D6d8Da48F36B8361C3d161e39fac" tenthBps="10" data-sentry-element="stargate-widget" data-sentry-source-file="page.tsx" />
      </Flex>
    </>;
}